import { useQuery } from '@tanstack/react-query';
import ProjectsService from '../services/projects';
import { queryKeys } from './queryKeys';

/**
 * List the account's projects, React-Query cached.
 *
 * Replaces ProjectsPage's manual useEffect/useState fetch loop. The win: the
 * list is account-scoped (one key, no params) and persisted, so navigating
 * back to /projects serves the cached rows instantly — `isLoading` is only
 * true on the very first load (no data yet), so the skeleton no longer flashes
 * on every visit. A short stale window still revalidates in the background
 * (stale-while-revalidate) so a project created/edited elsewhere shows up.
 */
export const useProjects = (options = {}) => {
  return useQuery({
    queryKey: queryKeys.projects.list(),
    queryFn: async () => {
      const response = await ProjectsService.getProjects();
      return response?.projects || [];
    },
    // Short stale window so coming back after a create/edit refetches in the
    // background, but the cached rows paint immediately (no skeleton flash).
    staleTime: 10 * 1000,
    ...options,
  });
};

export default useProjects;
